export const devicesKey = 'devices';
export const deviceLogFolders = 'device-log-folders';
export const deviceLogFolderFiles = 'device-log-folder-files';
export const deviceWebsocketsLogs = 'device-websockets-logs';
